module.exports = __webpack_public_path__ + "475104210ecdef34b5c576925b603016.jpg";